import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
  Text,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>Общие положения</Summary>
        <Details>
          <Text>
            1.1. Настоящие условия использования самообслуживания (далее –{" "}
            <strong>Условия</strong>) PlusPlus Baltic OÜ (регистрационный код
            12273105, адрес: Тарту мнт. 83, 10115 Таллинн, далее –{" "}
            <strong>PlusPlus</strong>) регулируют использование среды
            самообслуживания PlusPlus (далее – <strong>Самообслуживание</strong>
            ) физическими лицами, которые имеют денежную обязанность перед
            PlusPlus и которые внесены в связанные с Самообслуживанием системы
            PlusPlus (далее - <strong>Клиент</strong>).
          </Text>
          <Text>
            1.2. Самообслуживание позволяет Клиенту получить обзор данных,
            связанных с требованиями PlusPlus и обязанностями Клиента, а также
            совершать посредством компьютерной сети дозволенные PlusPlus
            действия.
          </Text>
          <Text>
            1.3. Используя Самообслуживание, Клиент подтверждает, что
            ознакомился с Условиями, принимает Условия и обязуется их соблюдать.
            Условия являются для Клиента обязательными до тех пор, пока Клиент
            является пользователем Самообслуживания.
          </Text>
          <Text>
            1.4. В дополнение к Условиям, войдя в Самообслуживание и совершая
            там действия, Клиент обязан следовать любым дополнительным
            указаниям, данным PlusPlus в Самообслуживании.
          </Text>
          <Text>
            1.5. PlusPlus оставляет за собой право в одностороннем порядке без
            уведомления Клиента изменять функции Самообслуживания и объем
            предоставляемых через Самообслуживание услуг и действий, а также
            порядок их использования.
          </Text>
          <Text>
            1.6. PlusPlus вправе проводить технические работы в
            Самообслуживании, и PlusPlus извещает о планируемых технических
            работах или сбоях в предоставлении услуги через Самообслуживание или
            веб-страницу PlusPlus (www.plusplus.ee).
          </Text>
          <Text>
            1.7. PlusPlus вправе в любое время изменить Условия, оповестив об
            этом Клиента через Самообслуживание или свою веб-страницу
            (www.plusplus.ee). Изменения Условий вступают в силу со дня
            публикации изменений в Самообслуживании или на веб-странице, если в
            измененных Условиях не установлено иначе.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Вход в Самообслуживание и безопасность</Summary>
        <Details>
          <Text>
            2.1. Для пользования Самообслуживанием Клиенту следует войти в
            Самообслуживание, используя предусмотренные для этого возможности.
          </Text>
          <Text>
            2.2. Первый раз Клиент может войти в Самообслуживание с помощью
            ID-карты или Mobiil-ID.
          </Text>
          <Text>
            2.3. После первого входа Клиент может создать свой аккаунт, и в этом
            случае в дальнейшем Клиент сможет входить в Самообслуживание также и
            через аккаунт, используя при входе имя пользователя и пароль.
          </Text>
          <Text>
            2.4. Выбранный Клиентом пароль Самообслуживания является
            конфиденциальной информацией, которую Клиент обязуется хранить в
            тайне и не разглашать третьим лицам.
          </Text>
          <Text>
            2.5. Наличие необходимого и подходящего для пользования
            Самообслуживанием оборудования и программного обеспечения Клиент
            должен обеспечить сам. Клиент обязан обеспечить, чтобы его решения в
            области безопасности и прочие решения (в т. ч. антивирусная
            программа) соответствовали современным стандартам и не блокировали
            использование Самообслуживания.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Права, обязанности и ответственность Клиента</Summary>
        <Details>
          <Text>3.1. Клиент обязуется:</Text>
          <Text>
            3.1.1. хранить в безопасности пароль Самообслуживания, PIN- и
            PUK-коды ID-карты, PIN- и PUK-коды Mobiil-ID и избегать их попадания
            во владение третьих лиц, а также не отдавать свою ID-карту третьим
            лицам;
          </Text>
          <Text>
            3.1.2. хранить в безопасности и не разглашать третьим лицам любую
            иную связанную с Клиентом или PlusPlus конфиденциальную информацию,
            а также избегать возможности получения третьими лицами доступа к
            упомянутой информации;
          </Text>
          <Text>
            3.1.3. незамедлительно оповестить PlusPlus о том, что пароль
            Самообслуживания, PIN- или PUK-коды ID-карты, PIN- или PUK-коды
            Mobiil-ID стали известны третьим лицам, и о любом ином
            обстоятельстве, которое может обусловить ненадлежащее использование
            Самообслуживания от имени Клиента;
          </Text>
          <Text>
            3.1.4. обеспечить, чтобы третьи лица не имели доступа к адресу(-ам)
            электронной почты, который(-е) Клиент сообщил PlusPlus, с
            которым(-и) связан аккаунт Клиента;
          </Text>
          <Text>
            3.1.5. следить за тем, чтобы используемые в Самообслуживании данные
            были действительными и верными, и в случае изменения контактных
            данных в течение 10 (десяти) дней сделать соответствующие изменения
            в указанных в Самообслуживании данных Клиента.
          </Text>
          <Text>
            3.2. Клиент отвечает за все принятые через Самообслуживание
            обязанности и совершенные действия, а также за верность введенных
            Клиентом данных.
          </Text>
          <Text>
            3.3. Клиент знает и подтверждает, что представленные через
            Самообслуживание волеизъявления, документы и осуществленные действия
            Клиента являются юридически обязательными, обладают равной
            юридической силой с подписанными собственноручно документами, и
            Клиент отвечает за все возникшие обязанности Клиента. PlusPlus
            вправе требовать подписать представляемые через Самообслуживание
            документы в электронном виде.
          </Text>
          <Text>
            3.4. Клиент может в любое время отказаться от использования
            Самообслуживания, сообщив об этом желании PlusPlus, используя
            контактные данные, указанные на веб-странице PlusPlus. После этого
            PlusPlus блокирует доступ Клиента к Самообслуживанию.
          </Text>
          <Text>
            3.5. В случае если Клиент желает задать вопрос или внести
            предложение по поводу Самообслуживания, он может связаться с отделом
            обслуживания клиентов через веб-страницу PlusPlus или отправить
            сообщение на адрес электронной почты (info@plusplus.ee).
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Права и обязанности PlusPlus</Summary>
        <Details>
          <Text>
            4.1. PlusPlus вправе прекратить или ограничить доступ к
            Самообслуживанию либо отказать в акцептировании осуществленных в
            Самообслуживании действий в случае, если:
          </Text>
          <Text>
            4.1.1. пароль Самообслуживания Клиента вводится по меньшей мере три
            раза неверно; или
          </Text>
          <Text>
            4.1.2. PlusPlus стало известно обстоятельство, на основании которого
            можно сделать вывод, что средства, необходимые для осуществления
            действия Клиента в Самообслуживании, стали известны третьему лицу;
            или
          </Text>
          <Text>
            4.1.3. PlusPlus установило направленную против Самообслуживания
            деятельность, произведенную с компьютера, использованного для входа
            в Самообслуживание или осуществления действий в Самообслуживании;
            или
          </Text>
          <Text>
            4.1.4. PlusPlus установило, что Самообслуживание использовалось
            способом, противоречащим действующим правовым актам; или
          </Text>
          <Text>4.1.5. Клиент нарушил Условия; или</Text>
          <Text>
            4.1.6. Клиент нарушил заключенное с PlusPlus соглашение или
            вытекающие из договора обязанности и не выполнил упомянутые
            обязанности в течение предоставленного со стороны PlusPlus
            дополнительного срока.
          </Text>
          <Text>
            4.2. PlusPlus вправе в любое время временно или окончательно
            прекратить предоставление Клиенту услуги Самообслуживания, оповестив
            об этом Клиента.
          </Text>
          <Text>
            4.3. Если у PlusPlus возникают сомнения в подлинности или
            достоверности представленных Клиентом через Самообслуживание
            документов или данных, то PlusPlus вправе потребовать от Клиента
            представления дополнительных документов или данных, и Клиент обязан
            их представить.
          </Text>
          <Text>
            4.4. PlusPlus не отвечает за причиненный Клиенту ущерб, если третье
            лицо войдет в портал Самообслуживания, используя данные, пароли
            и/или PIN-коды Клиента, и осуществит действия от имени Клиента.
          </Text>
          <Text>
            4.5. PlusPlus не отвечает за поломки и нарушения в работе
            Самообслуживания, причиной которых послужили оборудование Клиента,
            конфигурация электронной почты Клиента, перегруженность или
            несоответствие компьютера Клиента необходимым для использования
            Самообслуживания требованиям к информационным технологиям.
          </Text>
          <Text>
            4.6. PlusPlus не несет ответственности за ущерб, возникший у Клиента
            по причине невозможности использования Самообслуживания в связи с
            любыми техническими поломками или сбоями.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Защита интеллектуальной собственности</Summary>
        <Details>
          <Text>
            5.1. Среда самообслуживания является собственностью PlusPlus,
            авторские права на содержание среды (в т. ч. графика, текст,
            логотипы, иконки, изображения) и программное обеспечение принадлежат
            PlusPlus и защищены правовыми актами, регулирующими защиту
            интеллектуальной собственности.
          </Text>
          <Text>
            5.2. Формы, содержание и данные среды Самообслуживания недопустимо
            копировать, размножать, передавать, продавать или использовать иным
            способом нецеленаправленно (в т. ч. в коммерческих целях).
            Копирование, распространение, передача, разглашение или изменение
            Самообслуживания не допускается и влечет за собой ответственность в
            соответствии с Законом об авторском праве и другими правовыми
            актами, регулирующими защиту интеллектуальной собственности.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Обработка персональных данных</Summary>
        <Details>
          <Text>
            6.1. PlusPlus обрабатывает личные данные Клиентов согласно
            персональным данным, которые доступны по адресу{" "}
            <a
              href="https://plusplus.ee/ru/уведомление-о-конфиденциальности/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://plusplus.ee/ru/уведомление-о-конфиденциальности/
            </a>
          </Text>
          <Text>Настоящие условия вступают в силу с 1.08.2018.</Text>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
